import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { PlacementChatPage } from "../PlacementChats/PlacementChatPage";
import { WorkplaceModalsDataProvider } from "../ShiftDiscovery/useWorkplaceModalsDataContext";
import { HiringInstantPayFormPage } from "./components/HiringInstantPay/HiringInstantPayFormPage";
import { HiringInstantPayTrialPage } from "./components/HiringInstantPay/HiringInstantPayTrialPage";
import { HiringInstantPayConfettiProvider } from "./components/HiringInstantPayConfettiProvider";
import { PlacementDetailsPageV2 } from "./components/PlacementDetailsPage/PlacementDetailsPageV2";
import { PlacementReferralPage } from "./components/PlacementReferrals/Page";
import { PlacementsRootPage } from "./RootPage";
import { WorkplaceModalRoutes } from "./WorkplaceModalRoutes";

export function PlacementRoutes(): ReactElement {
  const match = useRouteMatch();

  const isInterviewsOutcome = useRouteMatch(`${match.url}/interviews/outcome`);
  const detailsOrChatMatch = useRouteMatch(`${match.url}/:placementId`);

  const isInDetailsOrChat = Boolean(detailsOrChatMatch) && !isInterviewsOutcome;

  return (
    <HiringInstantPayConfettiProvider>
      <ThemeProvider theme={getTheme()}>
        <CssBaseline />

        <WorkplaceModalsDataProvider baseNavigationPath={match.url}>
          <WorkplaceModalRoutes />
        </WorkplaceModalsDataProvider>
      </ThemeProvider>
      <Route path={`${match.url}`}>
        {/* Always mounted, but hides itself when a detail/chat page is open. */}
        <PlacementsRootPage hidden={isInDetailsOrChat} />
      </Route>
      <Switch>
        <Route exact path={`${match.url}/hiring-instant-pay-trial`}>
          <HiringInstantPayTrialPage />
        </Route>
        <Route exact path={`${match.url}/hiring-instant-pay`}>
          <HiringInstantPayFormPage />
        </Route>
        <Route exact path={`${match.url}/:placementId`}>
          <PlacementDetailsPageV2 />
        </Route>
        <Route exact path={`${match.url}/:placementId/placement-candidate/:placementCandidateId`}>
          <PlacementDetailsPageV2 />
        </Route>
        <Route path={`${match.url}/:placementId/referrals`}>
          <PlacementReferralPage />
        </Route>
        <Route path={`${match.url}/:placementId/workplace/:workplaceId/chat`}>
          <PlacementChatPage />
        </Route>
      </Switch>
    </HiringInstantPayConfettiProvider>
  );
}
